<div [ngClass]="classes()" class="main-layout">
  <sidebar-v2 class="main-layout__sidebar" />
  <div class="main-layout__container">
    <ui-header class="main-layout__header" />
    @if (config().userHeader.show) {
      <user-header
        class="main-layout__user-header"
        [showEditProfile]="config().userHeader.showEditProfile" />
    }
    <div class="main-layout__content">
      <router-outlet></router-outlet>
    </div>
    @defer (on idle) {
      <ui-footer class="main-layout__footer" />
    }
  </div>
</div>
